<template>
    <div class="table-responsive">
        <table class="table table-bordered table-sm table-hover">
            <thead>
            <tr class="table-title">
                <th scope="col" width="10%">Month</th>
                <th scope="col" width="30%">Active Subscriptions</th>
                <th scope="col" width="20%">One-off Signups (Past 90 Days)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="record in records" :key="record.id">
                <td>{{$moment(record.month, "YYYY-MM").format("MMMM - YYYY")}}</td>
                <td>{{record.active_member_count.toLocaleString()}}</td>
                <td>{{record.one_off_purchase_count_for_past_90_days.toLocaleString()}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
  name: 'ListTable',
  props: {
    records: {}
  }
}
</script>

<style scoped>

</style>
